/** Relationship decisions are independent of work eligibility and payment approval. */
export const supplierRelationshipStatuses = ['Not recorded', 'Current', 'Prospective', 'No longer used', 'Rejected', 'Non compliant', 'Not responsive', 'Suspended'];
export function supplierRelationshipStatus(row) {
    if (row.relationship_status)
        return row.relationship_status;
    // Retain explicit historical decisions, without inferring rejection from incomplete evidence.
    if (row.contractor_status === 'Rejected')
        return 'Rejected';
    if (row.contractor_status === 'Archived' || row.supplier_status === 'Archived')
        return 'No longer used';
    if (row.contractor_status === 'Suspended' || row.supplier_status === 'Suspended')
        return 'Suspended';
    return 'Not recorded';
}
export function supplierNotInUse(row) {
    return ['No longer used', 'Rejected', 'Non compliant', 'Not responsive', 'Suspended'].includes(supplierRelationshipStatus(row));
}
//# sourceMappingURL=supplier-relationship.js.map